if (!customElements.get('aliceparis-universe-slider')) {
  customElements.define('aliceparis-universe-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-ap-universe-slide]')];
      this.dots = [...this.querySelectorAll('[data-slide-to]')];
      this.media = this.querySelector('.aliceparis-universe__media');
      this.index = 0;
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.editorSelected = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onClick = (event) => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.dataset.action === 'previous') this.select(this.index - 1);
        if (button.dataset.action === 'next') this.select(this.index + 1);
        if (button.dataset.slideTo !== undefined) this.select(Number(button.dataset.slideTo));
      };
      this.onKeyDown = (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (!this.contains(document.activeElement)) return;
        event.preventDefault();
        this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      };
      this.onBlockSelect = (event) => {
        const slide = event.target.closest('[data-ap-universe-slide]');
        if (!slide || !this.contains(slide)) return;
        this.editorSelected = true;
        this.select(this.slides.indexOf(slide));
      };
      this.onVisibilityChange = () => this.updateAutoplay();
      this.onMotionChange = () => this.updateAutoplay();
      this.onPointerEnter = (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.updateAutoplay();
      };
      this.onPointerLeave = (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = false;
        this.updateAutoplay();
      };
      this.onPointerDown = (event) => {
        if (event.pointerType !== 'touch' || this.slides.length < 2 || event.target.closest('button')) return;
        this.touchStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
        this.media.setPointerCapture(event.pointerId);
        this.updateAutoplay();
      };
      this.onPointerUp = (event) => {
        if (!this.touchStart || this.touchStart.id !== event.pointerId) return;
        const distanceX = event.clientX - this.touchStart.x;
        const distanceY = event.clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(distanceX) >= 40 && Math.abs(distanceX) > Math.abs(distanceY) * 1.25) {
          this.select(this.index + (distanceX < 0 ? 1 : -1));
        } else this.updateAutoplay();
      };
      this.onPointerCancel = () => { this.touchStart = null; this.updateAutoplay(); };
      this.onFocusIn = () => { this.focused = true; this.updateAutoplay(); };
      this.onFocusOut = (event) => {
        if (this.contains(event.relatedTarget)) return;
        this.focused = false;
        this.updateAutoplay();
      };

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeyDown);
      this.addEventListener('pointerenter', this.onPointerEnter);
      this.addEventListener('pointerleave', this.onPointerLeave);
      this.media.addEventListener('pointerdown', this.onPointerDown);
      this.media.addEventListener('pointerup', this.onPointerUp);
      this.media.addEventListener('pointercancel', this.onPointerCancel);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      this.reducedMotion.addEventListener('change', this.onMotionChange);

      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.updateAutoplay();
      }, { threshold: 0.1 });
      this.observer.observe(this);
      this.select(0);
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeyDown);
      this.removeEventListener('pointerenter', this.onPointerEnter);
      this.removeEventListener('pointerleave', this.onPointerLeave);
      this.media?.removeEventListener('pointerdown', this.onPointerDown);
      this.media?.removeEventListener('pointerup', this.onPointerUp);
      this.media?.removeEventListener('pointercancel', this.onPointerCancel);
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('focusout', this.onFocusOut);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.reducedMotion?.removeEventListener('change', this.onMotionChange);
    }

    select(index) {
      if (this.slides.length < 2) return;
      this.index = ((index % this.slides.length) + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, position) => {
        const active = position === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, position) => {
        if (position === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      this.updateAutoplay();
    }

    stopAutoplay() {
      window.clearInterval(this.timer);
      this.timer = undefined;
    }

    updateAutoplay() {
      this.stopAutoplay();
      if (this.slides.length < 2 || this.dataset.autoplay !== 'true' || this.dataset.editor === 'true' ||
          this.reducedMotion.matches || document.hidden || !this.visible || this.hovered || this.focused || this.editorSelected || this.touchStart) return;
      const interval = Math.max(3000, Number(this.dataset.interval) || 6000);
      this.timer = window.setInterval(() => this.select(this.index + 1), interval);
    }
  });
}
